module.exports = __webpack_public_path__ + "static/media/covid19-tracker-min.e16319de.png";